import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import axios from 'axios';
import AdScreenV2 from './AdScreenV2';
import PageMarketingV2Menu from './PageMarketingV2Menu';

function PageMarketing() {
    function login(google_response) {
        axios.post(
            process.env.REACT_APP_API_HOST + '/login/',
            {
                token: google_response.credential,
            }
        ).then(
            (response) => {
                localStorage.setItem('token', google_response.credential);
                if (response.data.next == 'signup/google') {
                    window.location = '/signup/google';
                    return
                }
                if (response.data.next) {
                    window.location = '/feed/';
                    localStorage.setItem('user_id', response.data.user_id);
                    return
                }
            }
        ).catch(
            (error) => {
                console.log("ERROR");
                console.log(error);
            }
        );
    }

    return (
        <div
            align='center'
            style={{ marginTop: '4em' }}
        >
            <PageMarketingV2Menu />
            <div
                style={{
                    marginTop: '-2em',
                    paddingTop: '6em',
                    height: '100vh',
                }}
            >
                <GoogleOAuthProvider
                    clientId='201480255601-ksgcvg5976l3leiq1oujibq47dtjeols.apps.googleusercontent.com'
                >
                    <div style={{ width: '15em' }}>
                        <GoogleLogin
                            onSuccess={
                                (response) => {
                                    login(response);
                                }
                            }
                            onError={() => { console.log('err') }}
                            type='standard'
                            useOneTap={false}
                            text='continue_with'
                        />
                    </div>
                </GoogleOAuthProvider>
            </div>
        </div>
    );
}

export default PageMarketing;